<template>
  <div class="project-tenders">
    <div class="project-tenders__header">
      <div class="text-bs">{{ $t('Tenders') }}</div>
      <div class="project-tenders__header-actions spacex-28">
        <Button
          icon="plus"
          type="func"
          size="small"
          class="project-tenders__create-tender-btn"
          @click.native="createTender"
        >
          {{ $t('Create tender') }}
        </Button>
        <Button icon="list" type="func" size="small" @click.native="goToTenderList">
          {{ $t('View all') }}
        </Button>
      </div>
    </div>
    <div class="project-tenders__list">
      <DefaultErrorText v-if="tendersLoadingError" />
      <TenderCardSkeleton v-else-if="tendersLoading" />
      <ActiveTenderPlug v-else-if="!tenders.length" small class="py-46" @action="createTender" />
      <div v-else class="d-contents spacey-12">
        <SmallTenderCard
          v-for="tender in tenders"
          :key="tender.id"
          :tender="tender"
          @update-tenders="localLoadTender"
        />
        <TenderCardSkeleton v-if="moreTendersLoading" />
        <ShowArchivedButton
          v-else-if="!archivedTendersLoaded && projectHasArchivedTenders"
          @click.native="localLoadTender({ status: 'archived', additionally: true })"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import createTender from '@/utils/mixins/create-tender';
  import loadTenders from '@/utils/mixins/load-tenders';
  import SmallTenderCard from '@/components/tenders/tender-card/SmallTenderCard';
  import TenderCardSkeleton from '@/skeletons/project/tenders/TenderCardSkeleton';
  import ShowArchivedButton from '@/components/tender/tender-list/ShowArchivedButton';
  import ActiveTenderPlug from '@/components/tender/tender-list/ActiveTenderPlug';
  import DefaultErrorText from '@/components/ui/DefaultErrorText';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'ProjectTenders',
    components: {
      Button,
      ActiveTenderPlug,
      ShowArchivedButton,
      TenderCardSkeleton,
      SmallTenderCard,
      DefaultErrorText,
    },
    mixins: [createTender, loadTenders],
    computed: {
      ...mapState('projectTenders', [
        'tenders',
        'archivedTendersLoaded',
        'tendersLoading',
        'moreTendersLoading',
        'tendersLoadingError',
      ]),
      ...mapState('project', ['projectInfo']),
      projectHasArchivedTenders() {
        return this.projectInfo?.tenders_count > this.tenders.length;
      },
    },
    methods: {
      goToTenderList() {
        this.$router.push({ name: 'tenders', params: { status: 'active' } });
      },
    },
    async mounted() {
      await this.localLoadTender();
    },
  };
</script>
